<ng-container *ngIf="displayElement">
  <div class="vehicle-image">
    <div class="spinner" *ngIf="showSpinner"></div>
    <img #thumbnail (load)="onThumbnailComplete('SUCCESS')" (error)="onThumbnailComplete()" [hidden]="imageSuccess || !thumbSuccess" [style.max-width]="maxWidthImage" [style.max-height]="maxHeight" />
    <img #image (load)="onImageComplete('SUCCESS')" (error)="onImageComplete()" [hidden]="!imageSuccess" [style.max-width]="maxWidthImage" [style.max-height]="maxHeight" />
    <img #make class="make-logo" (load)="hideSpinner()" (error)="onMakeError()" [style.max-width]="maxWidthMake" [style.max-height]="maxHeight" />
  </div>
</ng-container>
